// @flow

import type {UserState, Action} from '../types'

const initialState: UserState = {
  entity: null,
}

const user = (state: UserState = initialState, action: Action) => {
  switch (action.type) {
    case 'SET_USER':
      return {
        ...state,
        entity: action.user,
      }
    default:
      return state
  }
}

export default user
